import React, { useEffect } from "react";
import usePageTitle from './shared/hooks/usePageTitle';

function LoggedOut() {
  usePageTitle('OSSDF Logged Out');
  useEffect(() => {
    // Optionally auto-redirect after a delay
    const timer = setTimeout(() => {
      window.location.href = `${process.env.PUBLIC_URL}/`;
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      maxWidth: 500,
      margin: "80px auto",
      padding: 32,
      border: "2px solid #ed1c24",
      borderRadius: 8,
      background: "#fff6f6",
      textAlign: "center"
    }}>
      <h2>You have been logged out</h2>
      <p>Your session has ended. Please log in again to continue.</p>
      <button
        style={{
          background: "#ed1c24",
          color: "#fff",
          border: "none",
          borderRadius: 3,
          padding: "10px 28px",
          fontSize: "1.1rem",
          fontWeight: 700,
          cursor: "pointer",
          marginTop: 24
        }}
        onClick={() => window.location.href = `${process.env.PUBLIC_URL}/`}
      >
        Log in again
      </button>
      <p style={{ marginTop: 16, color: "#888" }}>
        You will be automatically redirected to the login screen momentarily.
      </p>
    </div>
  );
}

export default LoggedOut;
